<div fxLayoutAlign="center center" class="breadcrumbs-container">
    <div fxFlex="60" fxFlex.md="70" fxFlex.sm="80" fxFlex.xs="95">
        <div fxLayout="row">
            <div fxFlex fxLayoutAlign="start center" fxHide.lt-md [style.visibility]="page == 'home' ? 'hidden' : ''">
                <ul class="breadcrumbs-one">
                    <li>
                        <a  id="home" [routerLink]="['/default']" class="current"><i class="fa fa-home"></i></a>
                    </li>
                    <li>
                        <a id="disclaimer" [routerLink]="['/default', {outlets: {'main': ['disclaimer']}}]">Disclaimer</a>
                    </li>
                    <li>
                        <a id="programme" [routerLink]="['/default', {outlets: {'main': ['programme']}}]">Programme</a>
                    </li>
                    <li>
                        <a id="modules" [routerLink]="['/default', {outlets: {'main': ['modules']}}]">Modules</a>
                    </li>
                    <li>
                        <a id="summary" [routerLink]="['/default', {outlets: {'main': ['summary']}}]">Summary</a>
                    </li>
                    <li>
                        <a id="personalinfo" [routerLink]="['/default', {outlets: {'main': ['personalinfo']}}]">Personal Info</a>
                    </li>
                    <li>
                        <a id="report" [routerLink]="['/default', {outlets: {'main': ['report']}}]">Report</a>
                    </li>
                </ul>
            </div>
            <div fxFlex fxLayoutAlign="start center" fxHide fxShow.lt-md>
                <button mat-button [routerLink]="['/default']" matTooltip="Home">
                    <mat-icon>home</mat-icon>
                </button>
            </div>
            <div fxFlex="40px" fxLayoutAlign="end center">
                <!--Only shows on disclaimer page-->
                <button mat-button *ngIf="isPageDisclaimer" matTooltip="Print disclaimer" (click)="printDisclaimer()">
                    <mat-icon>print</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>
<div class="print-section-wrapper">
    <div id="print-section">
        <div id="local-section">
            <app-disclaimercontent></app-disclaimercontent>
        </div>
        <div id="oversees-section">
            <app-disclaimercontentoversees></app-disclaimercontentoversees>
        </div>
    </div>
</div>
